module.exports = __webpack_public_path__ + "assets/img/securitiesSolutions-massive.8224ce30.png";